import React from 'react';
import { Spinner } from '@blueprintjs/core';

// Lazily loaded so the markdown renderer it pulls in stays out of the initial bundle.
const InstalledExtensionInfo = React.lazy(() => import('./InstalledExtensionInfo'));

const InstalledExtensionInfoPanel = (props) => (
    <React.Suspense fallback={<div style={{ marginTop: 50 }}><Spinner /></div>}>
        <InstalledExtensionInfo {...props} />
    </React.Suspense>
);

export default InstalledExtensionInfoPanel;
